<template>
    <div>
        <div class="mb-5 p-5 bg-white rounded">    
            <div class="d-lg-flex align-items-center justify-content-between mb-4 gap-2">
                <div class="justify-content-start d-flex">
                    <h3><strong style="color:#1A0054">Conoce lo que tenemos para tí</strong></h3>
                </div>                
            </div>  
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12 p-3">
                    <div class="bg-image" >
                        <a href=""><img src="/images/invita_colaboradores.jpg" alt=""></a>
                    </div>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-12">
                    <div class="bg-image">
                        <a href="https://wa.me/+5215592522981" target="_blank"><img src='/images/banner_utel_26092023.jpg' class="w-100" /></a>
                    </div>
                </div>
            </div>          
        </div>        
    </div>
</template>

<script>
export default {
    props: [
        
    ],
    data: function () {
        return {
            
        }
    },
    mounted() {
        
    },
    methods: {
    }
}
</script>

<style>

</style>